/*
	file: 			safeprice.js
	title: 			Detect browser chrome/firefox/edge/opera/other and add class to body
	use: 			Use with this css:
						body.detect-chrome .js-browser-chrome {
						    display: block;
						}
*/

(function() {
	'use strict';

	if(avastGlobals.detect.browser.isFirefox) {
		$('body').addClass('detect-firefox');
		}
	else if(avastGlobals.detect.browser.isChrome) {
		$('body').addClass('detect-chrome');
		}
	else if(avastGlobals.detect.browser.isEdge) {
		$('body').addClass('detect-edge');
		}
	else if(avastGlobals.detect.browser.isEdgeChromium) {
		$('body').addClass('detect-edge-chromium');
		}
	else if(avastGlobals.detect.browser.isOpera) {
		$('body').addClass('detect-opera');
		}
	else {
		$('body').addClass('detect-other');
		}
})();
